<template>
  <CreditCard
    :image-url="imageUrl"
    :name="name"
    :class="'credit-card--' + name"
  />
</template>
<script>
import CreditCard from './CreditCard'
import image from '../../../../../images/icons/credit_cards/american.gif'
export default {
  components: { CreditCard },
  data() {
    return {
      name: 'american',
      imageUrl: ''
    }
  },
  mounted() {
    this.imageUrl = image
  }
}
</script>
